<template>
	<div class="content-i">

			<div class="content-box">
				<matches :filter="$route.query" />
			</div>
		<!--------------------
		START - Sidebar
		-------------------->
		<div class="content-panel compact">
			<div class="content-panel-close" v-on:click="controlPanel()">
				<i class="os-icon os-icon-close"></i>
			</div>
			<div class="element-wrapper">
				<div class="element-actions actions-only">
					<div v-b-toggle.filter>
							<span class="when-opened">
								<i class="os-icon os-icon-minus-circle"></i>
							</span>
						<span class="when-closed">
								<i class="os-icon os-icon-plus-circle"></i>
							</span>
					</div>
				</div>
				<h6 class="element-header">
					<div v-b-toggle.filter>
						{{ t.filter.title }}
					</div>
				</h6>
				<div class="element-box-tp">
					<b-collapse id="filter">
						<filterGenerator :filter="filter"></filterGenerator>
					</b-collapse>
				</div>
			</div>
			<trendWidget />
		</div>
		<!--------------------
		END - Sidebar
		-------------------->
	</div>
</template>

<script>
    import VueFormGenerator from "vue-form-generator/dist/vfg-core.js";
    import filterGenerator from '@/components/form/filter';
    import matches from '@/components/stats/matches';
    import trendWidget from '@/components/user/bets/widget/trends'

    export default {
        name: 'fixture',
        components: { filterGenerator,matches,trendWidget },

        data () {
            return {
                app: this.$root.app,
                filter: [],
                msg: '',
                t: this.$root.t,
                filter: {},
                sports: [],
                competitions: [],
                regions: []
            }
        },
        watch: {
            accessToken () {
                this.getUserSession();
                this.getWs();
            }
        },
        mounted () {
            this.fetchDataForFilter();
            this.filterFixture();
        },
        methods: {
            onChangePage (page) {
                this.pagination.current = page;
                this.filter.page = page;

                var upc = this.$route.query.upcoming;
                this.$router.push({});

                this.$router.query.push({ page: page });


                window.scroll(0, 0);
            },
            filterFixture () {
                this.filter = {
                    model: {
                        page: 1,
                        match: '',
                        competitor: [],
                        startDate: '',
                        endDate: '',
                        sport: [],
                        region: [],
                        competition: [],
                        resultStatus: [],
                        allTime: 0
                    },
                    schema: {
                        fields: [
                            {
                                type: "Datepicker",
                                class: 'test',
                                label: this.t.start_date,
                                model: "startDate",
                                readonly: false,
                                featured: false,
                                disabled: false
                            },
                            {
                                type: "Datepicker",
                                class: 'test',
                                label: this.t.end_date,
                                model: "endDate",
                                readonly: false,
                                featured: false,
                                disabled: false
                            },
                            {
                                type: "input",
                                inputType: "text",
                                label: this.t.match_id,
                                model: "match",
                                readonly: false,
                                featured: false,
                                disabled: false
                            },
                            {
                                type: "competitor",
                                label: this.t.team_or_player,
                                model: "match",
                                readonly: false,
                                featured: false,
                                disabled: false
                            },
                            {
                                type: "checklist",
                                label: this.t.sport.title,
                                model: "sport",
                                multi: true,
                                required: false,
                                multiSelect: true,
                                values: this.sports,
                                checklistOptions: {
                                    value: "sportId",
                                    name: "name"
                                }
                            },
                            {
                                type: "checklist",
                                label: this.t.region.title,
                                model: "region",
                                multi: true,
                                required: false,
                                multiSelect: true,
                                values: this.regions,
                                checklistOptions: {
                                    value: "regionId",
                                    name: "name"
                                }
                            },
                            {
                                type: "checklist",
                                label: this.t.competition.title,
                                model: "competition",
                                multi: true,
                                required: false,
                                multiSelect: true,
                                values: this.competitions,
                                checklistOptions: {
                                    value: "competitionId",
                                    name: "name"
                                }
                            },
                            {
                                type: "checklist",
                                label: this.t.process_type,
                                model: "resultStatus",
                                multi: true,
                                required: false,
                                multiSelect: true,
                                values: this.processTypes,
                                checklistOptions: {
                                    value: "id",
                                    name: "name"
                                }
                            },
                            {
                                type: "switch",
                                label: this.t.all_time,
                                model: "allTime",
                                multi: true,
                                readonly: false,
                                featured: false,
                                disabled: false,
                                default: true
                            },
                            {
                                type: "submit",
                                label: "",
                                buttonText: "Filtrele",
                                onSubmit: this.filterNow,
                                validateBeforeSubmit: false,
                            }
                        ]
                    },
                    options: {
                        validateAfterLoad: true,
                        validateAfterChanged: true
                    }
                }
            },
            filterNow: function() {
                var model = this.$route.query;
                this.$router.push({ query: {} });
                this.$router.push({ query: this.filter.model });
                window.scrollTo(0,0);
            },
            fetchDataForFilter: function() {

                this.$http.get(bsapi+'api/v1/fixture/matches', {
                    params:  {withoutMatch: 1}
                }).then(response => {
                    // get body data
                    var sport = response.body.result.sport;
                    this.processTypes = response.body.status;

                    for (var key in sport) {
                        this.sports.push(sport[key]);

                        var region = sport[key]['region'];
                        for (var rkey in region) {
                            this.regions.push(region[rkey]);

                            var competition = region[rkey]['competition'];
                            for (var ckey in competition) {
                                this.competitions.push(competition[ckey]);
                            }
                        }
                    }
                }, response => {

                })
            }
        }
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
	.filter-area {
		padding: 5px 20px 5px 20px;
		box-shadow: inset 10px 10px 20px -10px rgba(0,0,0,0.21);
		min-height: 100%;
		float: left;
		width: 20%;
		background-color: #f6f7f8;
	}
	.fixture-area {
		padding: 20px 20px;
		min-height: 100%;
		float: right;
		width: 80%;
	}
</style>



// WEBPACK FOOTER //
// src/components/stats/fixture.vue